<template>
  <div>
    <DataTable :url="api.ACTIONS.RIDES_RATINGS($route.params.id)" :enable-delete="false" descending :sortable="false"
      :enable-edit="false" :enable-add="false" :title="false" :actions-extra-main="actionsExtraMain" :titles="titles"
      :formatter="formatters">
    </DataTable>
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";

export default {
  name: "Ratings",
  components: { DataTable },
  props: ["captain_id"],
  data() {
    return {
      loading: false,
      formatters: {
        datetime(value) {
          return moment(value).format("DD-MM-YYYY  HH:mm");
        },
        passenger_rating(value) {
          if (!value) return "";
          const rating = parseFloat(value);
          const fullStars = Math.floor(rating);
          const hasHalfStar = rating % 1 >= 0.5;
          const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
          
          let starsHtml = "";
          // Full stars
          for (let i = 0; i < fullStars; i++) {
            starsHtml += '<i class="material-icons" style="color: #FFB300; font-size: 18px; vertical-align: middle;">star</i>';
          }
          // Half star
          if (hasHalfStar) {
            starsHtml += '<i class="material-icons" style="color: #FFB300; font-size: 18px; vertical-align: middle;">star_half</i>';
          }
          // Empty stars
          for (let i = 0; i < emptyStars; i++) {
            starsHtml += '<i class="material-icons" style="color: #E0E0E0; font-size: 18px; vertical-align: middle;">star_border</i>';
          }
          starsHtml += `<span style="margin-left: 8px; color: #757575; font-size: 14px;">(${rating})</span>`;
          return starsHtml;
        },
        passenger_rating_cause(value) {
          if (!value) return "";
          return value.length > 50 ? value.substring(0, 50) + "..." : value;
        }
      },
    };
  },
  computed: {
    titles() {
      return {
        id: this.$t("drivers.ratings.booking"),
        datetime: this.$t("drivers.ratings.datetime"),
        passenger_name: this.$t("drivers.ratings.passenger"),
        pick_up_location_name: this.$t("drivers.ratings.pickUpLocation"),
        drop_off_location_name: this.$t("drivers.ratings.dropOffLocation"),
        passenger_rating: this.$t("drivers.ratings.passengerRating"),
        passenger_rating_cause: this.$t("drivers.ratings.passengerComment")
      };
    },
    actionsExtraMain() {
      return {
        details: {
          title: this.$t("drivers.ratings.orderDetails"),

          icon: "map",
          action: (item) => {
            const route = this.$router.resolve({
              name: "Rides",
              params: {
                id: item.id
              },
            });
            window.open(route.href, '_blank');
          }

        },
      };
    }
  },
  mounted() {
  },
};
</script>

<style scoped></style>
